export const GET_TEST_STANDARD = 'test-standard/test-standard-form-start';
export const GET_TEST_STANDARD_ERROR = 'test-standard/test-standard-form-error';
export const TEST_STANDARD_FORM_CLEAR =
  'test-standard/test-standard-form-clear';
export const TEST_STANDARD_SINGLE_SUCCESS =
  'test-standard/test-standard-form-single-success';
export const TEST_STANDARD_UPDATE_SUCCESS =
  'test-standard/test-standard-form-update-success';
